import Button, {
  ButtonSize,
  ButtonVariant,
} from "@shared/components/ui/Button";
import React from "react";

const TutorSubscriptionLimit: React.FC = () => {
  return (
    <div className="p-6 text-center h-full flex flex-col items-center justify-center">
      <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-amber-100 mb-4">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-8 w-8 text-amber-600"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
          />
        </svg>
      </div>
      <h2 className="text-xl font-bold mb-2">Upgrade Required</h2>
      <p className="text-gray-600 dark:text-gray-300 mb-4 text-sm">
        Tutor access is only available for users with a premium subscription.
      </p>
      <Button
        variant={ButtonVariant.PRIMARY}
        size={ButtonSize.MEDIUM}
        as="navlink"
        to="/settings/plans"
      >
        Upgrade Now
      </Button>
    </div>
  );
};

export default TutorSubscriptionLimit;
